import { generateMedia } from 'styled-media-query';

export const BREAKPOINTS = {
  desktop: '1200px',
  tablet: '992px',
  mobile: '768px',
};

export const MEDIA_QUERIES = {
  tablet: `(min-width: ${BREAKPOINTS.tablet})`,
};

const media = generateMedia(BREAKPOINTS);

export default media;
